@use "../../styles/breakpoint.module.scss" as *;

@media ($above-mobile) {
    .content[class*="gridStart1"] {
        padding-right: var(--spacer-24);
    }

    .content:not([class*="gridStart1"]) {
        padding-left: var(--spacer-24);
    }
}
